import { Chart, ChartTimerName } from '@frontend/chart/types';

import { createMonthlyTimeSeriesMockData } from '../../../mocks/create-time-series-mock-data';

export const TRANSACTION_TIMER_PICK_UP_PENDING_COMPLETED_VOLUME_BAR_CHART_MOCK_DATA: Chart = createMonthlyTimeSeriesMockData({
    series: [{ name: ChartTimerName.TRANSACTION_PICK_UP_PENDING, scale: 0.7 }]
});
